import { render, staticRenderFns } from "./ServiceDetailTabs.vue?vue&type=template&id=984d3000&"
import script from "./ServiceDetailTabs.vue?vue&type=script&lang=js&"
export * from "./ServiceDetailTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports